import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_4 = { class: "fs13 fw600 ddgrey text-left pad10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = { class: "w100" }
const _hoisted_8 = {
  class: "w15 fl",
  style: {}
}
const _hoisted_9 = {
  key: 0,
  class: "rad6 greenBg fs12 pad3 fw600 posAb z1",
  style: {"top":"-10px","left":"10px","height":"25px","width":"30px","padding-top":"5px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "w80 fl"
}
const _hoisted_12 = {
  key: 0,
  class: "w100 fs24 fw600 arial pad20"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "w80 fl"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  class: "fl",
  style: {"width":"400px"}
}
const _hoisted_18 = {
  style: {"width":"400px"},
  class: "mt20"
}
const _hoisted_19 = {
  key: 0,
  class: "alertRed fs12 fw600"
}
const _hoisted_20 = {
  class: "fl mt6",
  style: {"width":"calc(100% - 30px)"}
}
const _hoisted_21 = ["src", "onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = {
  style: {"width":"400px"},
  class: "mt20"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = {
  class: "fl",
  style: {"width":"calc(100% - 400px)"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "mt20"
}
const _hoisted_30 = {
  key: 0,
  class: "w100 fs24 fw600 arial pad20"
}
const _hoisted_31 = {
  key: 2,
  class: "w80 fl"
}
const _hoisted_32 = { key: 2 }
const _hoisted_33 = {
  style: {"width":"400px"},
  class: "fl mt20"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "fs13 fw600 ddgrey text-left pad10" }, [
  /*#__PURE__*/_createTextVNode(" 指定したメンバー（waaqLink登録済）に担当を割り当てます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 外部カレンダーに連携しているメンバーでも、自動で登録されません。自動で登録したい場合は、「外部カレンダーから割り当て」で対象のカレンダーを選択してください。 ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = {
  class: "SuggestsCalendarListContent ofs fl rad8 w98",
  style: {"height":"300px","box-shadow":"0 2px 4px rgba(0, 0, 0, 0.3)","border-top":"1px solid #ebebeb","border-bottom":"1px solid #ebebeb"}
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  style: {"width":"30px","height":"30px"},
  class: "fl ml10 mt6"
}
const _hoisted_39 = {
  class: "ml5 fl mt6",
  style: {"width":"calc(100% - 48px)"}
}
const _hoisted_40 = { class: "fs13 mt1 mb1" }
const _hoisted_41 = { class: "grey fs10" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = {
  key: 0,
  style: {"width":"300px"},
  class: "fl mt20"
}
const _hoisted_44 = {
  style: {"width":"30px","height":"30px"},
  class: "fl ml10 mt6"
}
const _hoisted_45 = {
  class: "ml5 fl mt6",
  style: {"width":"calc(100% - 48px)"}
}
const _hoisted_46 = { class: "fs13 mt1 mb1" }
const _hoisted_47 = { class: "grey fs10" }
const _hoisted_48 = ["src", "onClick"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OneMagSmallContent = _resolveComponent("OneMagSmallContent")!
  const _component_ScheduleSlideContent = _resolveComponent("ScheduleSlideContent")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_SearchCalendarsContent = _resolveComponent("SearchCalendarsContent")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.Util.isPresent(_ctx.mags))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl pad10 ${
                    _ctx.selectedTabName == 'astag' ? 'selected fw600 lskyblueBg' : ''
                }`),
            style: {"width":"230px","line-height":"30px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategoryTab('astag')))
          }, " 調整カレンダーから割り当て ", 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                    _ctx.selectedTabName == `ctags` ? 'selected fw600' : ''
                } `),
        style: {"width":"230px"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategoryTab('ctags')))
      }, " 外部カレンダーから割り当て ", 2),
      (_ctx.showAssignFromEmails)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                    _ctx.selectedTabName == `emails` ? 'selected fw600' : ''
                } `),
            style: {"width":"230px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCategoryTab('emails')))
          }, " メールアドレスから割り当て ", 2))
        : _createCommentVNode("", true),
      _hoisted_2
    ]),
    (_ctx.selectedTabName == `astag` && _ctx.Util.isPresent(_ctx.mags))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(" 担当者を変更します。割り当てられた担当者に通知がいきます。"),
            _hoisted_5,
            _createTextVNode(" 「" + _toDisplayString(_ctx.astag.name) + "」の調整カレンダーの担当者グループを表示しています。 ", 1)
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mags, (mag, magindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mt20 posRe",
                  key: `${magindex}${_ctx.selectedMag ? _ctx.selectedMag.id : null}`
                }, [
                  (_ctx.pdm.possibleDates && _ctx.beforeSelectedMag && _ctx.beforeSelectedMag.id == mag.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 現在 "))
                    : _createCommentVNode("", true),
                  _createVNode(_component_OneMagSmallContent, {
                    class: "fl",
                    onSelectMag: _ctx.selectMag,
                    mag: mag,
                    selectedMag: _ctx.selectedMag
                  }, null, 8, ["onSelectMag", "mag", "selectedMag"]),
                  _hoisted_10
                ]))
              }), 128))
            ]),
            (_ctx.pdm.possibleDates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_ctx.appo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.CalendarUtil.toJpFormat(_ctx.appo.start_time, _ctx.appo.duration)), 1))
                    : _createCommentVNode("", true),
                  _hoisted_13,
                  _createVNode(_component_ScheduleSlideContent, {
                    from: `schedule`,
                    style: `margin-top:20px;`,
                    onSelect: _ctx.selectMag
                  }, null, 8, ["onSelect"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_RoomsLoader)
                ])),
            _hoisted_15
          ])
        ]))
      : (_ctx.selectedTabName == `ctags`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (!_ctx.didSelectWritableAttendees)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 書き込み可能な外部カレンダーを選択していません。 "))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.edittingAttendees, (ctag, ctagindex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "pad10 hoverLightGrey rad10 posRe",
                      style: {"height":"48px"},
                      key: `${ctagindex}${ctag.needVote}`
                    }, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(ctag.name), 1),
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                        width: "25",
                        height: "25",
                        class: "posAb fr pointer mt1",
                        style: {"right":"10px"},
                        onClick: ($event: any) => (_ctx.deleteSelectCtag(ctag))
                      }, null, 8, _hoisted_21),
                      _hoisted_22
                    ]))
                  }), 128))
                ]),
                _hoisted_23
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_SearchCalendarsContent, {
                  ref: "SearchCalendarsContent",
                  autoLoadWeeklyCalendar: _ctx.autoLoadWeeklyCalendar
                }, null, 8, ["autoLoadWeeklyCalendar"]),
                _hoisted_25
              ]),
              _hoisted_26
            ]),
            _createElementVNode("div", _hoisted_27, [
              ((_ctx.cm.edittingAttendees || []).length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fl pointer centered circle_button blueAround fs14 rad8 mt15 ml20 fw600",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkEventsInTmpMag && _ctx.checkEventsInTmpMag(...args)))
                  }, " 日程を確認 "))
                : _createCommentVNode("", true),
              _hoisted_28,
              (_ctx.dailyEvents)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_ctx.appo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.CalendarUtil.toJpFormat(_ctx.appo.start_time, _ctx.appo.duration)), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ScheduleSlideContent, {
                      from: `schedule_custom`,
                      style: `margin-top:20px;`,
                      onSelect: _ctx.selectMag,
                      dailyEvents: _ctx.dailyEvents
                    }, null, 8, ["onSelect", "dailyEvents"])
                  ]))
                : (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createVNode(_component_RoomsLoader)
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]))
        : (_ctx.selectedTabName == `emails`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _hoisted_35,
                _createElementVNode("div", null, [
                  _createVNode(_component_MdTextfieldTag, {
                    name: "追加で通知するメールアドレス",
                    style: {"height":"56px","min-width":"100%"},
                    fieldStyle: "min-width:100%;",
                    class: "fl fs14 mb5",
                    value: _ctx.searchText,
                    onInputValue: _ctx.inputEmails
                  }, null, 8, ["value", "onInputValue"]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedMems, (ctag, ctagindex) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `${ctagindex}${ctag.name}`,
                          style: {"height":"46px"},
                          class: _normalizeClass(`pointer w100 ofh posRe hoverLgreyBg`),
                          onClick: ($event: any) => (_ctx.selectMember(ctag))
                        }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_UserIcon, {
                              member: ctag,
                              width: 28,
                              canEdit: false,
                              updateSelf: false,
                              showTooltip: false
                            }, null, 8, ["member"])
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_40, [
                              _createTextVNode(_toDisplayString(_ctx.truncate(ctag.name || ``, 20)), 1)
                            ])), [
                              [_directive_tooltip, ctag.name && ctag.name.length > 20 ? ctag.name : null]
                            ]),
                            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.truncate(ctag.email, 40)), 1)
                          ]),
                          _hoisted_42
                        ], 8, _hoisted_37))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              (_ctx.Util.isPresent(_ctx.tmpMagFromMail.registrable_attendees))
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tmpMagFromMail.registrable_attendees, (ctag, ctagindex) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `${ctagindex}${ctag.name}`,
                          style: {"height":"46px"},
                          class: _normalizeClass(`pointer w100 ofh posRe hoverLgreyBg`)
                        }, [
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_UserIcon, {
                              member: ctag,
                              width: 28,
                              canEdit: false,
                              updateSelf: false,
                              showTooltip: false
                            }, null, 8, ["member"])
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_46, [
                              _createTextVNode(_toDisplayString(_ctx.truncate(ctag.name || ``, 20)), 1)
                            ])), [
                              [_directive_tooltip, ctag.name && ctag.name.length > 20 ? ctag.name : null]
                            ]),
                            _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.truncate(ctag.email, 40)), 1)
                          ]),
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                            width: "25",
                            height: "25",
                            class: "posAb fr pointer mt1",
                            style: {"right":"10px"},
                            onClick: ($event: any) => (_ctx.deleteSelectedMember(ctag))
                          }, null, 8, _hoisted_48),
                          _hoisted_49
                        ]))
                      }), 128))
                    ]),
                    _hoisted_50
                  ]))
                : _createCommentVNode("", true),
              _hoisted_51
            ]))
          : _createCommentVNode("", true)
  ]))
}